var navbar = {

  init() {
    // Add open state to nav toggler icon
    $('.navbar-toggler').on('click', function () {
      $('.nav-icon').toggleClass('open');
    });

    //scroll background added
    $(window).on('scroll load', function() {
      var scrollPosition = $(this).scrollTop();
      var scrollThreshold = 50;
      $('.navbar').toggleClass('show-bg', scrollPosition > scrollThreshold);
      // $('.mega-menu-brush').toggleClass('alt', scrollPosition > scrollThreshold);
    });
    // $(document).ready(function() {
    // });
  },
};

export default navbar;



// WEBPACK FOOTER //
// ./scripts/modules/navbar.js